import type * as Actions from './actions';
import { ActionTypes as Types } from './actionTypes';

import type { DateRange, PageableContent, Sort } from '@cobliteam/common-types';

import type { VehicleRoute, VehicleRouteFilters } from '@cobliteam/api-lib';

export const loadVehicleRoutesRequest = (
  period: DateRange,
  page: number,
  size: number,
  filters?: VehicleRouteFilters,
  sort?: Sort
): Actions.LoadVehicleRoutesRequest => ({
  type: Types.LOAD_VEHICLE_ROUTES_REQUEST,
  payload: {
    period,
    page,
    size,
    filters,
    sort,
  },
});

export const loadVehicleRoutesSucceeded = (
  vehicleRoute: PageableContent<VehicleRoute>
): Actions.LoadVehicleRoutesSucceeded => ({
  type: Types.LOAD_VEHICLE_ROUTES_SUCCEEDED,
  payload: vehicleRoute,
});

export const loadVehicleRoutesFailed = (): Actions.LoadVehicleRoutesFailed => ({
  type: Types.LOAD_VEHICLE_ROUTES_FAILED,
});
